import { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../component/Header';
import FilterComponent from '../component/FilterComponent';
import Pagination from '../component/Pagination';
import MehrLesenCell from '../component/MehrLesenCell';
import Footer from '../component/Footer';
import NachObenButton from '../component/NachObenButton';
import { highlightText } from '../utils/utils';
import './BeListe.css';

import { BeListeProps, BeData, BeRow, ListHeader, ClickableButton, FilterButton, ActivableButton } from '../interfaces';
import BackendProvider from '../context/BackendContext';

const listHeaders: ListHeader[] = [
  { id: 1, name: 'Kürzel', field: 'b_intabk' },
  { id: 2, name: 'Name', field: 'b_name' },
  { id: 3, name: 'Vorwort', field: 'b_vorwort' },
  { id: 4, name: 'Systematik', field: 'sys_name' },
  { id: 5, name: 'Formular', field: 'f_name' }
];

const hitsMessage:string = ' Treffer mit Ihrem Filter finden Sie in der folgenden Tabelle';

function BeListe() {
  // const [beRow, setBeRow] = useState<BeRow>({ id: -1, abk: '', name: '', f_id: -1 });
  const [beList, setBeList] = useState([]);
  const [listEntries, setListEntries] = useState(10);
  const [page, setPage] = useState<number>(1);
  const [sorting, setSorting] = useState({ column: 'b_intabk', ascending: true });
  // const [filterText, setFilterText] = useState('');
  const hits = useRef<number>(0);
  const totalEntries = useRef(0);
  const navigate = useNavigate();
  const filterTextRef = useRef<string>('');

  // const stableURL = useRef(url);
  
  useEffect(() => {
    loadList();
  }, [sorting]);

  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, [page, listEntries]);
  
  const loadList = useCallback(() => {
    setPage(1);
    let url = '/webclient/php/be_liste.php?sortedBy=' + sorting.column + '&sortingOrder=' + sorting.ascending;
    if (filterTextRef.current !== '') {
      url += '&filterText=' + filterTextRef.current;
    } else {
      url += '&filterText=';
    }

    fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error('Anfrage fehlgeschlagen');
        }
        return res.json();
      })
      .then((data) => {
        setBeList(data);
        if (filterTextRef.current !== '') {
          hits.current = data.length;
        } else {
          hits.current = 0;  
        }
        totalEntries.current = data.length;
      })
      .catch((err) => {
        console.log(err.message);
      });
  }, [filterTextRef.current, sorting]);

  function setNewBeRow(beRow:BeRow) {
    const newRow = {
      id: beRow.id,
      abk: beRow.abk,
      name: beRow.name,
      f_id: beRow.f_id
    };
  }

  const setFilterTextRef = useCallback((text: string) => {
    filterTextRef.current = text;
  }, []);

  function handleClick(beRow:BeRow) {
    const beId:string = beRow.id.toString();
    const fId:string = beRow.f_id.toString();
    const urlParams = new URLSearchParams({ beId, abk: beRow.abk, name: beRow.name, fId }).toString(); 
    navigate(`/veliste?${urlParams}`);
    // setNewBeRow(beRow);
  }

  function handleDoubleClick(beRow:BeRow) {
    setNewBeRow(beRow);
    
    // changeView('BestandDetails');
  }

  function sortColumn(column:string) {
    if (column === sorting.column) {
      setSorting({ ...sorting, ascending: !sorting.ascending });
    } else {
      setSorting({ column: column, ascending: true });
    }
  }

  function handleHeaderKeyDown(event:React.KeyboardEvent<HTMLDivElement >, column:string) {
    if (event.key === 'Enter' || event.key === ' ') {
      sortColumn(column);
    }
  }

  function handleRowKeyDown(event:React.KeyboardEvent<HTMLDivElement >, beRow:BeRow) {
    if (event.key === 'Enter' || event.key === ' ') {
      handleClick(beRow);
    }
  }

  return (
    <>
      {/* <BackendProvider><Header /></BackendProvider> */}
      <Header />
      <div className="be-liste">
        <main role="main" className="be-liste-content" aria-label="Lookup-Liste über alle Bestände">
          <div className="be-liste-header">

            <h1>Bestandsregie</h1>

            <div role="toolbar" aria-label="Menüleiste" className="toolbar">
              <div className="be-list-tools">
                <FilterComponent label="Bestände" loadList={loadList} setFilterTextRef={setFilterTextRef} />
              </div>
              <Pagination entries={listEntries} setEntries={setListEntries} totalEntries={totalEntries.current} page={page} setPage={setPage} />
            </div>
          </div>

          {hits.current > 0 && <h2 className="filter-message">{hits.current + hitsMessage}</h2>}
          <div className="table-wrap">

            {/* 
            <table aria-label="Liste der Bestände" className="table be-liste-table">
              <thead>
                <tr>
                  {listHeaders.map((row: ListHeader) => (
                    <th
                      key={row.id}
                      className={sorting.column === row.field ? (sorting.ascending === true ? 'h2 order-arrow-box asc-order' : 'h2 order-arrow-box desc-order') : 'h2'}
                      title={sorting.column === row.field ? (sorting.ascending === true ? 'Spalteninhalt absteigend sortieren' : 'Spalteninhalt aufsteigend sortieren') : 'Spalteninhalt aufsteigend sortieren'}
                      aria-sort={sorting.column === row.field ? (sorting.ascending ? 'ascending' : 'descending') : 'none'}
                      aria-label={sorting.column === row.field ? (sorting.ascending === true ? 'Spalteninhalt absteigend sortieren' : 'Spalteninhalt aufsteigend sortieren') : 'Spalteninhalt aufsteigend sortieren'}
                      tabIndex={0}
                      onClick={() => sortColumn(row.field)}
                      onKeyDown={(e) => handleHeaderKeyDown(e, row.field)}
                    >
                      {row.name}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {beList.slice((page - 1) * listEntries, page * listEntries).map(
                  (row: BeData) => {
                    const beRow: BeRow = { id: row.id, abk: row.abk, name: row.name, f_id: row.f_id };

                    return (
                      <tr
                        key={row.id}
                        tabIndex={0}
                        aria-label="Bestand öffnet sich per Klick"
                        onClick={() => handleClick(beRow)}
                        onKeyDown={(e) => handleRowKeyDown(e, beRow)}
                        title="Bestand öffnet sich per Klick"
                      >
                        <td>{highlightText(row.abk.toString(), filterTextRef.current)}</td>
                        <td>{highlightText(row.name, filterTextRef.current)}</td>
                        <td>
                          <MehrLesenCell
                            text={typeof row.vorwort === 'string' ? row.vorwort : ''}
                            filterText={filterTextRef.current}
                            tooltipText={'Text für ' + listHeaders[2].name + ' Bestand ' + row.name + ' anzeigen'} 
                          />
                        </td>
                        <td>{row.sys_name}</td>
                        <td>{row.f_name}</td>
                      </tr>
                    );
                  }
                )}
              </tbody>
            </table>

            */}

            <div role="table" aria-label="Liste der Bestände" className="be-liste-role-table">  
              <div className="table-header" role="rowgroup">
                <div role="row">
                  {listHeaders.map((row: ListHeader) => (
                    <div
                      key={row.id}
                      className={sorting.column === row.field ? (sorting.ascending === true ? 'order-arrow-box asc-order' : 'order-arrow-box desc-order') : ''}
                      role="columnheader"
                      title={sorting.column === row.field ? (sorting.ascending === true ? 'Spalteninhalt absteigend sortieren' : 'Spalteninhalt aufsteigend sortieren') : 'Spalteninhalt aufsteigend sortieren'}
                      aria-sort={sorting.column === row.field ? (sorting.ascending ? 'ascending' : 'descending') : 'none'}
                      aria-label={sorting.column === row.field ? (sorting.ascending === true ? 'Spalteninhalt absteigend sortieren' : 'Spalteninhalt aufsteigend sortieren') : 'Spalteninhalt aufsteigend sortieren'}
                      tabIndex={0}
                      onClick={() => sortColumn(row.field)}
                      onKeyDown={(e) => handleHeaderKeyDown(e, row.field)}
                    >
                      {row.name}
                    </div>
                  ))}
                </div>
              </div>

              <div role="rowgroup">
                {beList.slice((page - 1) * listEntries, page * listEntries).map(
                  (row: BeData) => {
                    const beRow: BeRow = { id: row.id, abk: row.abk, name: row.name, f_id: row.f_id };

                    return (
                      <div 
                        key={row.id}
                        role="row"
                        tabIndex={0}
                        aria-label="Bestand öffnet sich per Klick"
                        onClick={() => handleClick(beRow)}
                        onKeyDown={(e) => handleRowKeyDown(e, beRow)}
                        title="Bestand öffnet sich per Klick"
                      >
                        <div role="cell">{highlightText(row.abk.toString(), filterTextRef.current)}</div>
                        <div role="cell">{highlightText(row.name, filterTextRef.current)}</div>
                        <div role="cell">
                          <MehrLesenCell
                            text={typeof row.vorwort === 'string' ? row.vorwort : ''}
                            filterText={filterTextRef.current}
                            tooltipText={'Text für ' + listHeaders[2].name + ' Bestand ' + row.name + ' anzeigen'} 
                          />
                        </div>
                        <div role="cell">{row.sys_name}</div>
                        <div role="cell">{row.f_name}</div>
                      </div>
                    );
                  }
                )}
              </div>
            </div>

            {beList.slice((page - 1) * listEntries, page * listEntries).map(
              (row: BeData) => {
                const beRow: BeRow = { id: row.id, abk: row.abk, name: row.name, f_id: row.f_id };

                return (
                  <div className="table-with-button" key={row.id}>
                    <table key={row.id} className="table-responsive-md">
                      <tbody>
                        <tr>
                          <th className="h2">{listHeaders[0].name}</th>
                          <td onClick={() => handleClick(beRow)}>{row.abk}</td>
                        </tr>
                        <tr>
                          <th className="h2">{listHeaders[1].name}</th>
                          <td onClick={() => handleClick(beRow)}>{row.name}</td>
                        </tr>
                        <tr>
                          <th className="h2">{listHeaders[2].name}</th>
                          <td onClick={() => handleClick(beRow)}>
                            <MehrLesenCell
                              key={row.id}
                              filterText={filterTextRef.current}
                              text={typeof row.vorwort === 'string' ? row.vorwort : ''}
                              tooltipText="Text für Beschreibung Bestand Amt Löptin anzeigen" 
                            />
                          </td>
                        </tr>
                        <tr>
                          <th className="h2">{listHeaders[3].name}</th>
                          <td onClick={() => handleClick(beRow)}>{row.sys_name}</td>
                        </tr>
                        <tr>
                          <th className="h2">{listHeaders[4].name}</th>
                          <td onClick={() => handleClick(beRow)}>{row.f_name}</td>
                        </tr>
                      </tbody>
                    </table>
                    <button type="button" onClick={() => handleClick(beRow)} />
                  </div>
                );
              }
            )}
          </div>
        </main>
      </div>
      <NachObenButton />
      <Footer />
    </>
  );
}

export default BeListe;
